import {
  DestinationType,
  DiscoverBaseUrlRequest,
  DiscoverRequest,
} from 'APP/wsApi/routerContractApi/types/router/router_requests_pb';
import {
  DiscoverBaseUrlResponse,
  DiscoverDestination,
  DiscoverResult,
  ResponseData,
} from 'APP/wsApi/routerContractApi/types/router/router_responses_pb';
import { ProjectInstallationType } from 'CONFIG_TYPES';
import { createDiscoverDestinationWithKey } from 'UTILS/discoverDestinationsUtils';

import {
  IDiscoverDestination,
  IGetDiscoverDestinationsRequestParams,
  ITenantRouterUrls,
} from './tenantRouterModel.types';

export function mapGetUnauthorizedRoutingResponse(responseData: ResponseData): ITenantRouterUrls {
  const urlsConfig = responseData.configs[0];
  return {
    liveKitCallsUrl: urlsConfig.domainCallSocketUrl,
    wsApiUrl: urlsConfig.domainSocketUrl,
    bffUrl: urlsConfig.domainRestUrl,
    unauthorizedUrl: urlsConfig.domainUnauthorizedCallUrl,
  };
}

function mapDestinationTypeRequest(type?: ProjectInstallationType): DestinationType {
  switch (type) {
    case ProjectInstallationType.CloudOnly:
      return DestinationType.CLOUD_ONLY;
    case ProjectInstallationType.OnPremiseOnly:
      return DestinationType.ON_PREMISE_ONLY;
    case ProjectInstallationType.AllInOne:
    default:
      return DestinationType.ALL_IN_ONE;
  }
}

function mapDestinationTypeResponse(type?: DestinationType): ProjectInstallationType {
  switch (type) {
    case DestinationType.CLOUD_ONLY:
      return ProjectInstallationType.CloudOnly;
    case DestinationType.ON_PREMISE_ONLY:
      return ProjectInstallationType.OnPremiseOnly;
    case DestinationType.ALL_IN_ONE:
    default:
      return ProjectInstallationType.AllInOne;
  }
}

export function mapGetDiscoverDestinationsRequest(
  params: IGetDiscoverDestinationsRequestParams
): Omit<DiscoverRequest, '$typeName'> {
  return {
    email: params.email,
    orgSlug: params.orgSlug,
    type: mapDestinationTypeRequest(params.type),
  };
}

export function mapGetDiscoverDestinationItemResponse(
  destination: DiscoverDestination
): IDiscoverDestination {
  return createDiscoverDestinationWithKey({
    alias: destination.alias || '',
    type: mapDestinationTypeResponse(destination.type),
  });
}

export function mapGetDiscoverDestinationsResponse(
  response: DiscoverResult
): IDiscoverDestination[] {
  return response.destinations.map(mapGetDiscoverDestinationItemResponse);
}

export function mapGetDiscoverBaseUrlRequest(
  destination: IDiscoverDestination
): Omit<DiscoverBaseUrlRequest, '$typeName'> {
  return {
    alias: destination.alias,
    type: mapDestinationTypeRequest(destination.type),
  };
}

export function mapGetDiscoverBaseUrlResponse(response: DiscoverBaseUrlResponse): string {
  return response.success?.baseUrl || '';
}
